import { FC } from 'react'
import { Box, Typography } from '@mui/material'
import styled from '@emotion/styled/macro'
import theme from 'theme'

const Container = styled(Box)`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`

const Wrapper = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: ${theme.spacing.large}px;
  width: 396px;
  background: transparent;
  box-shadow: none;

  /* ag-overlay-loading-center gets a framed panel from AG Grid's theme, visible on the light page. */
  &.ag-overlay-loading-center {
    border: none !important;
    background: transparent !important;
    box-shadow: none !important;
  }

  .description-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: ${theme.spacing.md}px;

    .title {
      color: ${theme.colors.neutral};
      font-family: ${theme.typography.fontFamily.primary};
      font-size: ${theme.typography.fontSize.xxxLarge};
      font-style: normal;
      font-weight: ${theme.typography.fontWeight.bold};
      line-height: normal;
    }

    .description {
      color: ${theme.baseColors.greyscale[80]};
      text-align: center;
      font-family: ${theme.typography.fontFamily.primary};
      font-size: ${theme.typography.fontSize.xLarge};
      font-style: normal;
      font-weight: ${theme.typography.fontWeight.normal};
      line-height: 24px;
    }
  }

  html[data-theme='light'] & {
    .description-wrapper .title {
      color: ${theme.colors.menuItemText};
    }

    .description-wrapper .description {
      color: ${theme.colors.devicesSecondaryText};
    }
  }
`

interface Props {
  blank?: boolean
  /* Overrides the "no data" copy for grids that are not the CPI operational view. */
  blankDescription?: string
}

const NoResultsFound: FC<Props> = ({ blank, blankDescription = 'No data for this CPI' }) => {
  return (
    <Container>
      <Wrapper className="no-results-wrapper ag-overlay-loading-center" role="presentation">
        <img src="/devices-no-results-icon.png" />

        <Box className="description-wrapper">
          <Typography className="title">No Results Found</Typography>
          <Typography className="description">
            {blank
              ? blankDescription
              : 'Try changing the filter values or check back later when the devices become available in the table'}
          </Typography>
        </Box>
      </Wrapper>
    </Container>
  )
}

export default NoResultsFound
